module.exports = __webpack_public_path__ + "media/flags/mo-ba54ad4b.svg";